export default "__VITE_ASSET__DdS_Nf28__"